import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

const KEY = "fundai_cookie_consent";

function applyAnalyticsConsent(accepted) {
  try {
    const ph = window.posthog;
    if (!ph) return;
    if (accepted && typeof ph.opt_in_capturing === "function") ph.opt_in_capturing();
    if (!accepted && typeof ph.opt_out_capturing === "function") ph.opt_out_capturing();
  } catch {
    /* ignore */
  }
}

export default function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    try {
      const pref = localStorage.getItem(KEY);
      if (!pref) {
        setShow(true);
      } else {
        applyAnalyticsConsent(pref === "accepted");
      }
    } catch {
      setShow(true);
    }
  }, []);

  const choose = (val) => {
    try { localStorage.setItem(KEY, val); } catch { /* ignore */ }
    applyAnalyticsConsent(val === "accepted");
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 120, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 120, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
          className="fixed bottom-4 inset-x-4 md:left-auto md:right-6 md:max-w-md z-[60] glass rounded-2xl p-6 border border-white/10"
          data-testid="cookie-banner"
        >
          <p className="text-sm text-zinc-300 leading-relaxed">
            We use essential cookies to run this site and, with your consent, privacy-respecting analytics to improve it.
            You can reject non-essential cookies. See our <Link to="/legal/cookie-notice" className="text-[#00D1FF] hover:underline">Cookie Notice</Link>.
          </p>
          <div className="mt-4 flex gap-3">
            <button onClick={() => choose("accepted")} className="flex-1 bg-[#0057FF] hover:bg-[#0047D6] text-white rounded-full px-4 py-2.5 text-sm font-medium transition-colors active:scale-[0.98]" data-testid="cookie-accept-btn">Accept all</button>
            <button onClick={() => choose("rejected")} className="flex-1 border border-white/15 hover:border-white/40 text-white rounded-full px-4 py-2.5 text-sm font-medium transition-colors" data-testid="cookie-reject-btn">Reject non-essential</button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
